var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"words"},[_vm._l((_vm.words),function(word){return [(!word.guessed && !word.error)?_c('button',{class:['word', {
        loading: word.loading,
        focused: word.id === _vm.focusWord.id,
        help: !word.guessed && _vm.useHelp,
      }],attrs:{"disabled":word.selected},domProps:{"textContent":_vm._s(word.value)},on:{"click":function($event){return _vm.$emit('select', word)}}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }